"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertedOrder = void 0;
const class_transformer_1 = require("class-transformer");
const Order_1 = require("../models/Order");
let ConvertedOrder = class ConvertedOrder {
    order;
    errorMessages;
};
exports.ConvertedOrder = ConvertedOrder;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Order_1.Order)
], ConvertedOrder.prototype, "order", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ConvertedOrder.prototype, "errorMessages", void 0);
exports.ConvertedOrder = ConvertedOrder = __decorate([
    (0, class_transformer_1.Exclude)()
], ConvertedOrder);
//# sourceMappingURL=ConvertedOrder.js.map